import { render } from "./TheLogistikUmlagern.vue?vue&type=template&id=553e536c&scoped=true"
import script from "./TheLogistikUmlagern.vue?vue&type=script&lang=js"
export * from "./TheLogistikUmlagern.vue?vue&type=script&lang=js"

import "./TheLogistikUmlagern.vue?vue&type=style&index=0&id=553e536c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-553e536c"]])

export default __exports__